import React from 'react';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

const DateRangeFilter = ({
  updateQuery,
  dateRange,
  setDateRange,
}) => {
  const dateFormat = ['MM/DD/YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'];

  const handleCalendarChange = (range, dateString) => {
    if (range === null) {
      updateQuery({ start_date: null, end_date: null });
      setDateRange(null);
      return;
    }
    const [startDate, endDate] = dateString;
    updateQuery({
      start_date: startDate ? moment(startDate, dateFormat).format('YYYY-MM-DD') : null,
      end_date: endDate ? moment(endDate, dateFormat).format('YYYY-MM-DD') : null,
    });
    setDateRange(range);
  };

  return (
    <DatePicker.RangePicker
      className='voice-outbound-subheader-date-picker'
      placeholder={['Start Date', 'End Date']}
      value={dateRange}
      onCalendarChange={handleCalendarChange}
      style={{ minWidth: '250px' }}
      format={dateFormat}
    />
  )
};

DateRangeFilter.defaultProps = {
  updateQuery: () => {},
  dateRange: [],
  setDateRange: () => {},
}

DateRangeFilter.propTypes = {
  updateQuery: PropTypes.func,
  dateRange: PropTypes.array,
  setDateRange: PropTypes.func,
  isInbound: PropTypes.bool,
}

export default DateRangeFilter;
